import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { Tooltip } from '@jutro/components';
import { IconButton } from '@jutro/legacy/components';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useDataRefresh } from '@xengage/gw-portals-viewmodel-react';


import messages from './MLHVQDiscrepancyPropertyColomnComponent.messages';
import metadata from './MLHVQDiscrepancyPropertyColomnComponent.metadata.json5';
import styles from './MLHVQDiscrepancyPropertyColomnComponent.module.scss';

function MLHVQDiscrepancyPropertyColomnComponent(props) {
    const {
        discrepancyProperties,
        showPropertyGroupDoubleBorderStyle,
        discrepancyOwnerTitle,
        discrepancyHasUpdated,
        discrepancyOwner,
        handleDiscrepancyUpdate,
        isHomeowners
    } = props;
    const translator = useTranslator();
    const { refreshData } = useDataRefresh();

    const helpTextMap = {
        true: translator(messages.consumerReportHelpText)
    };

    const generateOverrides = () => {
        const overrides = discrepancyProperties.map((discrepancyPropertyVM, index) => {
            const constructAvailableValues = () => {
                return [
                    {
                        "code": "true",
                        "name": discrepancyPropertyVM.hvqValue && discrepancyPropertyVM.hvqValue.value

                    },
                    {
                        "code": "false",
                        "name": discrepancyPropertyVM.quoteValue && discrepancyPropertyVM.quoteValue.value
                    }
                ]
            };

            const constructDiscrepancyTitle = () => {
                return (
                    <div className={classNames(styles.discrepancyTitle, styles.boldText)}>{_.get(discrepancyPropertyVM, 'title.value')}</div>
                )
            }

            const constructDiscrepancyHeader = () => {
                return (
                    (isHomeowners ?
                        <div className={styles.discrepancyHeader}>
                            <div className={styles.discrepancyFlex}>
                                <h4 className={styles.discrepancyTitle}>{discrepancyOwnerTitle}</h4>
                            </div>
                            <div className={styles.discrepancyFlex}>
                                <span className={`${styles.discrepancyField} ${styles.fieldWidth}`}>{translator(messages.youEntered)}</span>
                                <span className={styles.discrepancyField}>{translator(messages.consumerReportsShow)}</span>
                                <Tooltip
                                    placement="bottom"
                                    content={translator(messages.consumerReportHelpText)}
                                >
                                    <IconButton
                                        className={styles.iconOverride}
                                        icon="mi-help-outline"
                                        onClick={() => { }}
                                    />
                                </Tooltip>
                            </div>
                        </div> :
                        <div className={styles.discrepancyHeader}>
                                <h4 className={styles.discrepancyTitle}>{discrepancyOwnerTitle}</h4>
                        <span className={styles.discrepancyField}>{translator(messages.youEntered)}</span>
                        <div>
                                <span className={styles.discrepancyField}>{translator(messages.consumerReportsShow)}</span>
                                <Tooltip
                                    placement="bottom"
                                    content={translator(messages.consumerReportHelpText)}
                                >
                                    <IconButton
                                        className={styles.iconOverride}
                                        icon="mi-help-outline"
                                        onClick={() => { }}
                                    />
                                </Tooltip>
                            </div>
                        </div>
                        )
                    )
            }

            return {
                discrepancyPropertyHeader: {
                    content: constructDiscrepancyHeader()
                },
                [`discrepancyTitle${index}`]: {
                    content: constructDiscrepancyTitle()
                },
                [`discrepancyPropertyRadioBtn${index}`]: {
                    controlClassName: styles.discrepancyRadioControl,
                    hideLabel: true,
                    availableValues: constructAvailableValues(),
                    value: _.get(discrepancyPropertyVM, 'keepHvqValue.value'),
                    onValueChange: (value) => {
                        _.set(discrepancyPropertyVM, 'keepHvqValue.value', value);
                        refreshData();
                        handleDiscrepancyUpdate && handleDiscrepancyUpdate(value, discrepancyPropertyVM, 'keepHvqValue.value', discrepancyOwner);
                        discrepancyHasUpdated(true);
                    },
                    showHelpText: false,
                    helpTextTitleMap: {},
                    helpTextMap: helpTextMap,
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const overrideProps = {
        discrepancyProperty: {
            data: discrepancyProperties
        },
        mlHVQDiscrepancyPropertyGroupContainer: {
            className: showPropertyGroupDoubleBorderStyle ? 'ml-section double-border' : ''
        },
        ...generateOverrides()
    }

    const resolvers = {
        resolveClassNameMap: styles
    }

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
}

MLHVQDiscrepancyPropertyColomnComponent.propTypes = {
    discrepancyProperties: PropTypes.array,
    showPropertyGroupDoubleBorderStyle: PropTypes.bool,
    discrepancyHasUpdated: PropTypes.func.isRequired,
    handleDiscrepancyUpdate: PropTypes.func,
    discrepancyOwner: PropTypes.string,
    isHomeowners: PropTypes.bool,
}

MLHVQDiscrepancyPropertyColomnComponent.defaultProps = {
    discrepancyProperties: [],
    showPropertyGroupDoubleBorderStyle: true,
    discrepancyHasUpdated: undefined,
    handleDiscrepancyUpdate: undefined,
    discrepancyOwner: undefined,
    isHomeowners: false
}

export default MLHVQDiscrepancyPropertyColomnComponent;